import * as ActionTypes from "constants/ActionTypes";
import deepEqual from "deep-equal";
import getInitialPlaybackState from "utils/getInitialPlaybackState";
import defaults from "lodash/defaults";
import produce from "immer";

const defaultPlaybackState = getInitialPlaybackState();

export default function playbackState(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SEEK_FORWARD:
      return produce(state, (draft) => {
        if (draft?.[action.stateKey]?.time != null) {
          draft[action.stateKey].time += 15000;
        }
      });
    case ActionTypes.SEEK_BACK:
      return produce(state, (draft) => {
        if (draft?.[action.stateKey]?.time != null) {
          draft[action.stateKey].time = Math.max(
            0,
            draft[action.stateKey].time - 15000,
          );
        }
      });

    case ActionTypes.CHANGE_PLAYBACK_STATE: {
      let newState = action.value;
      const oldState = state[action.stateKey];

      if (oldState) {
        if (newState.playing && oldState.userInitiatedPause) {
          newState.userInitiatedPause = false;
        }

        if (newState.scrubbing) {
          newState.timeBeforeScrub = oldState.time;
        }

        if (oldState.didInitiallyStall && newState.playing) {
          newState.didInitiallyStall = false;
        }

        newState = {
          ...oldState,
          ...newState,
        };

        if (deepEqual(oldState, newState)) return state;
      }

      return {
        ...state,
        [action.stateKey]: defaults(newState, defaultPlaybackState),
      };
    }
    case ActionTypes.DESTROY_PLAYBACK_STATE: {
      const destroyAction = action;
      if (!state[destroyAction.stateKey]) return state;

      return Object.keys(state).reduce((memo, key) => {
        if (key === destroyAction.stateKey) return memo;

        return {
          ...memo,
          [key]: state[key],
        };
      }, {});
    }
    case ActionTypes.RESET_INITIAL_STATE:
      return {};
    default:
      return state;
  }
}
